// extracted by mini-css-extract-plugin
export default {"header":"_7WCHbfbH8A4VKw67emHEtw==","editLink":"Q4HzCm+CPS-tH6hbum-gPg=="};